import { render, staticRenderFns } from "./Grafica4.vue?vue&type=template&id=3f7b1df2&"
import script from "./Grafica4.vue?vue&type=script&lang=js&"
export * from "./Grafica4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports